import { useState, useEffect } from 'react'

import { useEsri } from '../hooks'
import { useUserPreference } from '../../user/hooks'
import { PREFERENCES } from '../../user/constants'

import { TRAFFIC_LAYER_URL } from '../constants'

const esriReqs = ['esri/layers/MapImageLayer']

const TrafficLayer = ({ map, view }) => {
  const showTraffic = useUserPreference(PREFERENCES.SHOW_TRAFFIC)
  const [ready, { MapImageLayer }] = useEsri(esriReqs)
  const [layer, setLayer] = useState(null)

  useEffect(() => {
    if (ready && map) {
      if (layer && !showTraffic) {
        map.remove(layer)
        setLayer(null)
      } else if (layer === null && showTraffic) {
        const newLayer = new MapImageLayer({
          url: TRAFFIC_LAYER_URL,
          refreshInterval: 0.5,
        })
        map.add(newLayer)
        setLayer(newLayer)
      }
    }
  }, [ready, MapImageLayer, map, layer, showTraffic])

  return null
}

export default TrafficLayer
